import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/uniuni-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const UniUniLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function UniUniLogo(props, ref) {
    const logoProps = getLogoProps(props, {
      primary: { light: '#1d1d1b', dark: '#ffffff' },
    })

    return <Logo {...logoProps} ref={ref} />
  },
)
